export default "__VITE_ASSET__D4MISj32__"